import firebase from 'firebase'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'

Vue.config.productionTip = false

Vue.prototype.$moment = moment

// Test config.
var firebaseConfig = {}

if (process.env.NODE_ENV === 'production') {
    firebaseConfig = {
        apiKey: 'AIzaSyB8s3FRylQtKXRNn95o649Xv2sxWjWMg34',
        authDomain: 'northleedsmensfastball.firebaseapp.com',
        databaseURL: 'https://northleedsmensfastball.firebaseio.com',
        projectId: 'northleedsmensfastball',
        storageBucket: 'northleedsmensfastball.appspot.com',
        messagingSenderId: '340263953988',
        appId: '1:340263953988:web:1348171ce0196d87'
    }
} else {
    firebaseConfig = {
        apiKey: 'AIzaSyAFyclf1JiSvDj1roFuA8g8hy0uSn6_yM4',
        authDomain: 'northleedsmensfastball-test.firebaseapp.com',
        databaseURL: 'https://northleedsmensfastball-test.firebaseio.com',
        projectId: 'northleedsmensfastball-test',
        storageBucket: 'northleedsmensfastball-test.appspot.com',
        messagingSenderId: '120900474503',
        appId: '1:120900474503:web:494e7c345b2e2c9c'
    }
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const db = firebase.firestore()
export const timestamp = firebase.firestore.Timestamp

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
